import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CostCenterEntity, CostCenterEntityListResponse, CostCenterEntityQueryParams, CreateCostCenterEntity } from '@frontend/cost-center/types';

export class CostCenterEntityClient extends APIClient {
    public static readonly endpoint = '/cost-center-api/v1';

    public static async fetchCostCenterEntities(queryParams?: ApiQueryParams<CostCenterEntityQueryParams>): Promise<CostCenterEntityListResponse> {
        return await this.apiPaginated<CostCenterEntityListResponse, CostCenterEntityQueryParams>(`${this.endpoint}/cost-center-entities`, queryParams);
    }

    public static async resolveCostCenterEntities(ids: string[], field: string = 'id'): Promise<CostCenterEntityListResponse> {
        return this.resolve<CostCenterEntityListResponse>(`${this.endpoint}/cost-center-entities`, ids, field);
    }

    public static async deleteCostCenterEntities(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/cost-center-entities-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postCostCenterEntity(account_id: string, cost_center_id: string, body: CreateCostCenterEntity): Promise<CostCenterEntity> {
        const response = await this.post(`${this.endpoint}/accounts/${account_id}/cost-centers/${cost_center_id}/entities`, body);
        return await this.handleResponse<CostCenterEntity>(response);
    }

    public static async fetchCostCenterEntity(account_id: string, cost_center_id: string, cost_center_entity_id: string): Promise<CostCenterEntity> {
        const response = await this.fetch(`${this.endpoint}/accounts/${account_id}/cost-centers/${cost_center_id}/entities/${cost_center_entity_id}`);
        return await this.handleResponse<CostCenterEntity>(response);
    }

    public static async deleteCostCenterEntity(account_id: string, cost_center_id: string, cost_center_entity_id: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${account_id}/cost-centers/${cost_center_id}/entities/${cost_center_entity_id}`);
        return await this.handleVoidResponse(response);
    }
}
